// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.closed-mortgage{color:#2492df;text-align:center}`, "",{"version":3,"sources":["webpack://./src/components/rip/estate/Mortgages/ClosedMortgage.scss"],"names":[],"mappings":"AAAA,iBACI,aAAA,CACA,iBAAA","sourcesContent":[".closed-mortgage {\n    color: #2492df;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
